import { SxStyleProp } from 'rebass'

export const storyCardStyles: SxStyleProp = {
  paddingY: '10px',
  maxWidth: '262px',
  height: '335px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
}
